// React
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronDown as farChevronDown,
  faChevronUp as farChevronUp,
  faSpinnerThird as farSpinnerThird
} from '@fortawesome/pro-regular-svg-icons'

// Components
import BLine from 'shop-components/components/MiniCart/styles/Line'
import BundleItem from './BundleItem'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import ItemActions from 'back_office/v2/redux/actions/item_actions'

export const BundleContents = ({ line, fetchItems, t }) => {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const handleToggleOpen = () => {
    if (!loaded && !open) {
      setLoading(true)

      fetchItems(line.items.map((item) => item.item_id))
        .then(() => {
          setOpen(true)
          setLoaded(true)
        })
        .finally(() => {
          setLoading(false)
        })

      return
    }

    setOpen((prev) => !prev)
  }

  return (
    <BLine.BundleContents>
      <BLine.BundleContentsTitle onClick={handleToggleOpen}>
        {t('user.store.bundle_contents')}
        {' '}
        {line.items?.length > 0 && <span>({line.items.length})</span>}
        {!loading && <FontAwesomeIcon icon={open ? farChevronUp : farChevronDown} />}
        {loading && <FontAwesomeIcon icon={farSpinnerThird} spin />}
      </BLine.BundleContentsTitle>
      {open && line.items.map(({ item_id: id, quantity }, index) => (
        <BundleItem
          key={`${id}-${index}`}
          id={id}
          quantity={quantity}
        />
      ))}
    </BLine.BundleContents>
  )
}

BundleContents.displayName = 'LineBundleContents'

BundleContents.propTypes = {
  line: PropTypes.object,
  fetchItems: PropTypes.func,
  t: PropTypes.func
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchItems: (ids) => {
      return ItemActions.fetchAll({
        apiVersion: '4',
        include: ['photo'],
        filter: {
          id: ids
        },
        page: {
          size: 1000
        }
      })
    }
  }
}

export default compose(reduxConnect(null, mapDispatchToProps), withTranslation('user'))(BundleContents)
